module.exports = __webpack_public_path__ + "img/Beauty & Personal Care.cf8df44a.png";